import { defineStore } from 'pinia';
import { CalendarInstanceType, CalendarReservedSlotsType } from '@/types/Events/CalendarInstanceType';

export const useCalendarPageStore = defineStore('calendarPage', {
    state: () => ({
        calendar_reserved_slots: [] as Array<CalendarReservedSlotsType>,
        events: [] as Array<CalendarInstanceType>,
        events_reserved_slots_exists: [] as Array<string>,
        is_event_first_initial_exist: false,
    }),

    actions: {
        CALENDAR_RESERVED_SLOTS_EXISTS(month: string) {
            this.events_reserved_slots_exists.push(month);
        },

        REPLACE_CALENDAR_RESERVED_SLOTS_EXISTS(month: string) {
            this.events_reserved_slots_exists = [month];
        },

        SET_CALENDAR_EVENTS_SLOTS(data: Array<CalendarReservedSlotsType>) {
            this.calendar_reserved_slots = data;
        },

        SET_CALENDAR_EVENTS(newEvents: Array<CalendarInstanceType>) {
            this.events = newEvents;
        },

        UPDATE_CALENDAR_EVENTS(newEvents: Array<CalendarInstanceType>) {
            this.events.push(...newEvents);
        },

        SET_CALENDAR_CREATED_OR_EDITED_EVENT(event: CalendarInstanceType) {
            const existEventIndex = this.events.findIndex((item: CalendarInstanceType) => item.id === event.id);
            if (existEventIndex !== -1) {
                this.events.splice(existEventIndex, 1);
            }
            this.events.push(event);
        },

        CALENDAR_COMMIT_EVENTS_CONCAT(newEvents: Array<CalendarInstanceType>) {
            const eventForConcat = newEvents.filter(
                (item: CalendarInstanceType) => !(this.events.find(
                    (stateItem: CalendarInstanceType) => stateItem.id === item.id)
                )
            );
            this.events.push(...eventForConcat);
        },

        CALENDAR_COMMIT_RESERVED_SLOTS_CONCAT(data: Array<CalendarReservedSlotsType>) {
            this.calendar_reserved_slots.push(...data);
        },

        SET_EVENT_FIRST_INITIAL_EXIST(value: boolean) {
            this.is_event_first_initial_exist = value;
        },
    },
});
